export const tr = {
    'empty-rate': 'Belirtilmedi',
    title: 'Teklif düzenleme'
};
